import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import axios from "axios";
import useAuthStore from "../../store/useAuthStore";
import { fetchData as fetchDataNode } from "../nodeApi/fetchData";
const apiUrl = window._env_?.REACT_APP_BACKEND_URL;
// export const fetchData = async (endpoint, params) => {
//   const token = useAuthStore.getState().token;

//   const { data } = await axios.get(
//     `${apiUrl}${endpoint}`,
//     {
//       params: params,
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   );
//   return data;
// };

export const fetchData = async (endpoint, params, baseUrl,) => {
  const token = useAuthStore.getState().token;
  const url = `${baseUrl || apiUrl}${endpoint}`;

  try {
    const { data } = await axios.get(url, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    if (error.code === "ECONNABORTED" || (error.message && error.message.includes("timeout"))) {
      console.error("API request timed out");
      throw new Error("Request timed out. Please try again.");
    }
    throw error;
  }
};

// export const useStudentCourseList = () => {
//   return useQuery({
//     queryKey: ["student_course_list"],
//     queryFn: () => fetchData("student-courses-list"),
//   });
// };

// export const useExploreStudentCourses = (filters) => {
//   return useQuery({
//     queryKey: ["student_explore_courses", filters],
//     queryFn: async () => {
//       return await fetchData("student-explore-courses", filters);
//     },
//   });

// };


export const useCourseDetail = (id) => {
  return useQuery({
    queryKey: ["coursedetail", id],
    queryFn: async () => {
      const data = await fetchDataNode(`collab-course-view/${id}`);
      return data;
    },
    enabled: !!id,
  });
}

export const useEvents = () => {
  return useInfiniteQuery({
    queryKey: ["events"],
    queryFn: async ({ pageParam = 1 }) => {
      const data = await fetchData(`collab-events?page=${pageParam}`);
      data.data = data.data.filter(event => event.event_name !== null)
      return data;
    },
    getNextPageParam: (lastPage) => {
      return lastPage.current_page < lastPage.last_page ? lastPage.current_page + 1 : undefined;
    }
  });
};

export const useEventDetail = (id) => {
  return useQuery({
    queryKey: ["eventdetail", id],
    queryFn: async () => {
      const data = await fetchData(`collab-event-view/${id}`);
      return data;
    },
    enabled: !!id,
  });
}

// export const useStudentApartmentList = () => {
//   return useQuery({
//     queryKey: ["student_course_apartment_list"],
//     queryFn: () => fetchData("student-course-apartment-list"),
//   });
// };

export const useCourseCategory = () => {
  return useQuery({
    queryKey: ["category"],
    queryFn: () => fetchDataNode("collab-categories"),
  });
};

export const useStudentCourse = (filter) => {
  return useQuery({
    queryKey: ["student_courses", filter],
    queryFn: () => fetchDataNode("student-courses", filter),
  });
};


// export const useCourses = (filter) => {
//   return useInfiniteQuery({
//     queryKey: ["courses", filter],
//     queryFn: async ({ pageParam = 1 }) => {
//       const data = await fetchDataNode(`collab-courses?page=${pageParam}`, filter);
//       data.data = data.courses?.data;
//       return data;
//     },
//     getNextPageParam: (lastPage) => {
//       return lastPage.current_page < lastPage.last_page ? lastPage.current_page + 1 : undefined;
//     },
//     retry: false,
//     refetchOnWindowFocus: false,
//     refetchOnReconnect: false,

//   });
// };



export const useCourses = (filters) => {
  return useInfiniteQuery({
    queryKey: ["courses", filters],
    queryFn: async ({ pageParam = 1 }) => {
      const res = await fetchDataNode(
        `collab-courses?page=${pageParam}&limit=10`,
        filters,
      );

      return {
        data: res?.courses?.data || [],
        currentPage: res?.courses?.pagination?.current_page,
        totalPages: res?.courses?.pagination?.totalPages,
      };
    },

    getNextPageParam: (lastPage) => {
      if (lastPage.currentPage < lastPage.totalPages) {
        return lastPage.currentPage + 1;
      }
      return undefined;
    },
  });
};

// export const useCourseFilter = (filters) => {
//   return useQuery({
//     queryKey: ["course-filter", filters],
//     queryFn: async () => {
//       const data = await fetchData("collab-course-filter", filters);
//       data.data = data.data.sort((a, b) => b.is_featured - a.is_featured);
//       return data
//     },
//     enabled: filters && Object.keys(filters).length > 0,
//   });
// };

export const useStudentBookEventList = () => {
  return useQuery({
    queryKey: ["student_booked_events_list"],
    queryFn: () => fetchData("student-booked-events-list"),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export const useCourseApartmentList = (filters) => {
  return useQuery({
    queryKey: ["course_apartment_list", filters],
    queryFn: () => fetchDataNode("collab-apartment-by-course", filters),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

};

export const usePriceCourseDetail = (params) => {
  return useQuery({
    queryKey: ["collab-apartment-details-courses", params],
    queryFn: () => fetchDataNode(`collab-apartment-details/${params?.apartmentName}/${params?.title}`),
    enabled: !!params?.apartmentName && !!params?.title,
  });
};

export const usePriceEventDetail = (params) => {
  return useQuery({
    queryKey: ["collab-apartment-details-events", params],
    queryFn: () => fetchData(`collab-apartment-details-event/${params?.apartmentName}/${params?.title}`),
    enabled: !!params?.apartmentName && !!params?.title,
  });
};

export const useStudentList = (filter) => {
  return useQuery({
    queryKey: ["students-by-trainer", filter],
    queryFn: () => fetchDataNode(`students-by-trainer`, filter),
  });
};


export const useStudentListStatus = (filter) => {
  return useQuery({
    queryKey: ["students-by-trainer-status", filter],
    queryFn: () => fetchDataNode(`students-attendance-details`, filter),
  });
};


export const useStudentAtdList = (filters) => {
  return useQuery({
    queryKey: ["student-attendance-list", filters],
    queryFn: () => fetchDataNode(`student-attendance-list`, filters),
    enabled: filters && Object.keys(filters).length > 0,
  });
};



// export const useMemoryListall = () => {
//   return useQuery({
//     queryKey: ["student-memories-list-by-batch"],
//     queryFn: () => fetchData(`student-memories-list-by-batch`),
//   });
// };

export const useCreditScore = () => {
  return useQuery({
    queryKey: ["student-credit-count"],
    queryFn: () => fetchDataNode(`student-credit-count`),
  });
};

// export const useEventsApartmentList = (filters) => {
//   return useQuery({
//     queryKey: ["event_apartment_list", filters],
//     queryFn: () => fetchData("collab-apartment-by-event", filters),
//   });
// };

export const useMemoryByApart = (filters) => {
  return useInfiniteQuery({
    queryKey: ['get-images', filters],
    queryFn: async ({ pageParam = 1 }) =>
      fetchDataNode('get-images', { ...filters, page: pageParam }),
    getNextPageParam: (lastPage) => {
      const nextUrl = lastPage?.pagination?.next_page_url;
      if (!nextUrl) return undefined;

      // Extract ?page=2 from URL
      const url = new URL(nextUrl);
      return url.searchParams.get('page');
    },
  });
};


export const useNewCourseDetail = (filter) => {
  return useQuery({
    queryKey: ["new-course-details", filter],
    queryFn: () => fetchDataNode("new-course-details", filter),
  });
}


export const useNewCourseDetail1 = (filter) => {
  return useQuery({
    queryKey: ["new-course-assign-details", filter],
    queryFn: () => fetchDataNode(`new-course-assign-details`, filter),
    enabled: !!filter?.slug,
  });
};


export const useStudentOnlineCourses = (filter) => {
  return useQuery({
    queryKey: ["online-student-courses", filter],
    queryFn: () => fetchDataNode(`online-student-courses`, filter),

  });
};


export const useGetOnlineCourseSlot = (filter) => {
  return useQuery({
    queryKey: ["students/online-purchased-courses", filter],
    queryFn: () => fetchDataNode(`students/online-purchased-courses`, filter),

  });
};

export const useGetOnlineCourseDetail = (filters) => {
  return useQuery({
    queryKey: ["new-course-online", filters],
    queryFn: () => fetchDataNode(`new-course-online`, filters),
    enabled: !!filters?.slug,
  });
};

export const useStudentCurrentOnlineCourse = (filters) => {
  return useQuery({
    queryKey: ["student/currentday-online-courses", filters],
    queryFn: () => fetchDataNode(`student/currentday-online-courses`, filters)
  });
};

export const useStudentCurrentOfflineCourse = (filters) => {
  return useQuery({
    queryKey: ["student/currentday-offline-courses", filters],
    queryFn: () => fetchDataNode(`student/currentday-offline-courses`, filters)
  });
};

// export const useStudentMeeting = (id) => {
//   return useQuery({
//     queryKey: [`zoom-meeting/join-url`],
//     queryFn: () => fetchDataNode(`zoom-meeting/${id}/join-url`),
//   });
// };

export const useStudentMeeting = (filter) => {
  return useQuery({
    queryKey: [`zoom/join-url/student`, filter],
    queryFn: () => fetchDataNode(`zoom/join-url`, filter),
  });
};

export const useOnlineMeetingDetail = (filters) => {
  return useQuery({
    queryKey: [`online-batch-zoom-details`, filters],
    queryFn: () => fetchDataNode(`online-batch-zoom-details`, filters),
    enabled: !!filters?.batch_name
  });
};


export const useOfflineMeetingDetail = (filters) => {
  return useQuery({
    queryKey: [`schedules/offline`, filters],
    queryFn: () => fetchDataNode(`schedules/offline`, filters),
    // enabled: !!filters?.batch_name
  });
};


export const useGetUserDetail = (filters) => {
  return useQuery({
    queryKey: [`user/details`, filters],
    queryFn: () => fetchDataNode(`user/details`, filters),
  });
};


export const useGetUserPurchaseDetail = (filters) => {
  return useQuery({
    queryKey: [`purchase-details`, filters],
    queryFn: () => fetchDataNode(`purchase-details`, filters),
  });
};

export const useGetUserSummerPurchaseDetail = (filters) => {
  return useQuery({
    queryKey: [`new-course-assign-details-purchased`, filters],
    queryFn: () => fetchDataNode(`new-course-assign-details-purchased`, filters),
  });
};






